/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type PaginationData_pageInfo$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TrackContent_queryResult$ref: FragmentReference;
export type TrackContent_queryResult = {|
  +vendors_search: ?{|
    +page_info: ?{|
      +$fragmentRefs: PaginationData_pageInfo$ref
    |},
    +result: ?$ReadOnlyArray<?{|
      +id: string,
      +logo_url: ?string,
      +ref_id: string,
      +name: ?string,
      +rating_count: ?number,
      +avg_rating: ?number,
      +follow: ?boolean,
      +followed: ?boolean,
      +track: ?string,
      +city: ?{|
        +name: ?string
      |},
      +country: ?{|
        +name: ?string
      |},
      +featured: ?boolean,
      +departments: ?$ReadOnlyArray<?{|
        +id: string,
        +name: string,
      |}>,
      +track_sub_departments: ?$ReadOnlyArray<?{|
        +id: string,
        +name: string,
        +track_department_id: string,
        +ref_id: string,
      |}>,
    |}>,
    +related_sorts: $ReadOnlyArray<?{|
      +name: ?string,
      +display_name: ?string,
      +selected: ?boolean,
    |}>,
    +related_filters: ?$ReadOnlyArray<?{|
      +display_name: ?string,
      +name: ?string,
      +options: ?$ReadOnlyArray<?{|
        +selected: ?boolean,
        +count: ?number,
        +name: ?string,
        +value: ?string,
        +options: ?{|
          +display_name: ?string,
          +name: ?string,
          +options: ?$ReadOnlyArray<?{|
            +selected: ?boolean,
            +count: ?number,
            +name: ?string,
            +value: ?string,
          |}>,
        |},
      |}>,
    |}>,
    +errors: ?$ReadOnlyArray<?{|
      +field: ?string,
      +messages: ?$ReadOnlyArray<?string>,
      +code: ?number,
    |}>,
  |},
  +$refType: TrackContent_queryResult$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  v2
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "display_name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "selected",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "TrackContent_queryResult",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "input",
      "type": "VendorFilterInput",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "vendors_search",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input",
          "type": "VendorFilterInput"
        }
      ],
      "concreteType": "VendorsFilterResult",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "page_info",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PaginationData_pageInfo",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "result",
          "storageKey": null,
          "args": null,
          "concreteType": "Shop",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "followed",
              "args": null,
              "storageKey": null
            },
            v0,
            v1,
            v2,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "rating_count",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "avg_rating",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "follow",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "logo_url",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "track",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "city",
              "storageKey": null,
              "args": null,
              "concreteType": "State",
              "plural": false,
              "selections": v3
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "country",
              "storageKey": null,
              "args": null,
              "concreteType": "Country",
              "plural": false,
              "selections": v3
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "featured",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "departments",
              "storageKey": null,
              "args": null,
              "concreteType": "TrackDepartment",
              "plural": true,
              "selections": [
                v0,
                v2
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "track_sub_departments",
              "storageKey": null,
              "args": null,
              "concreteType": "TrackSubDepartment",
              "plural": true,
              "selections": [
                v0,
                v2,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "track_department_id",
                  "args": null,
                  "storageKey": null
                },
                v1
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "related_sorts",
          "storageKey": null,
          "args": null,
          "concreteType": "SortOption",
          "plural": true,
          "selections": [
            v2,
            v4,
            v5
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "related_filters",
          "storageKey": null,
          "args": null,
          "concreteType": "Search",
          "plural": true,
          "selections": [
            v4,
            v2,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "options",
              "storageKey": null,
              "args": null,
              "concreteType": "SearchOption",
              "plural": true,
              "selections": [
                v5,
                v6,
                v2,
                v7,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "options",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "OptionValueFilter",
                  "plural": false,
                  "selections": [
                    v4,
                    v2,
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "options",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "SearchOption",
                      "plural": true,
                      "selections": [
                        v5,
                        v6,
                        v2,
                        v7
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "errors",
          "storageKey": null,
          "args": null,
          "concreteType": "Error",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "field",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "messages",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "code",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '8d59e2a4863a9ab13588340b5eb75caa';
module.exports = node;
